import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { CURRENCIES } from '../../utils/currency';

const { Option } = Select;

/**
 * CurrencySelector Component
 * Select dropdown for choosing currency (USD or IQD)
 */
const CurrencySelector = ({
    value,
    onChange,
    style = {},
    disabled = false,
    size = 'middle'
}) => {
    const { t } = useTranslation('common');

    return (
        <Select
            value={value}
            onChange={onChange}
            style={{ width: 120, ...style }}
            disabled={disabled}
            size={size}
            placeholder={t('currency.selectCurrency')}
        >
            {Object.keys(CURRENCIES).map(code => (
                <Option key={code} value={code}>
                    {CURRENCIES[code].symbol} {t(`currency.${code.toLowerCase()}`)}
                </Option>
            ))}
        </Select>
    );
};

export default CurrencySelector;
